export const environment = {
    production: false,
    isApp: false,
    isMobile: false,
    local: false,
    apiUrl: "/client/listeners/api/pt.edp.edponline.",
    apiUrlEs: "/client/listeners/api/es.edp.edponline.",
    apiUrlV1: "/api/v2/",
    apiCatalogUrl: "/client/listeners/api/pt.edp.catalog.",
    b2bUrl: {
        PT: "https://m01.cliente.edp.pt",
        ES: "https://m01.cliente.edp.pt",
    },
    appUrl: {
        PT: "https://m01-particulares.cliente.edp.pt",
        ES: "https://m01.particulares.edpenergia.es"
    },
    appUrlV1: "https://m01-particulares.cliente.edp.pt",
    ssoUrl: {
        PT: "https://m01.login.edp.pt",
        ES: "https://m01.login.edpenergia.es"
    },
    url: {
        PT: "https://m01-particulares.cliente.edp.pt",
        ES: "https://m01.particulares.edpenergia.es",
    },
    firebase: {
        PT: {
            apiKey: "AIzaSyAsiETFVu1QhAHccR42xJzyRGnU24R0q9k",
            authDomain: "loginedp-edp-pre.firebaseapp.com",
            databaseURL: "https://loginedp-edp-pre.firebaseio.com",
            projectId: "loginedp-edp-pre",
            storageBucket: "loginedp-edp-pre.appspot.com",
            messagingSenderId: "630305056254",
        },
        ES: {
            apiKey: "AIzaSyAXo5z-xgZjoa9PfiTZpXgol4trSe4jqKI",
            authDomain: "loginedp-edpes-pre.firebaseapp.com",
            databaseURL: "https://loginedp-edpes-pre.firebaseio.com",
            projectId: "loginedp-edpes-pre",
            storageBucket: "loginedp-edpes-pre.appspot.com",
            messagingSenderId: "1073075453708",
        },
    },
    links: [
        {
            content: `<span class="edp-color-gray font-weight-medium">comunidade </span>
            <span class="edp-color-red font-weight-medium mr-1">edp</span>
            <i class="fa fa-external-link edp-color-gray" aria-hidden="true"></i>`,
            link: "https://staging.comunidadeedp.pt",
        },
        {
            content: `<span class="edp-color-red font-weight-medium">edp</span>
            <span class="edp-color-gray font-weight-medium mr-1">.pt</span>
            <i class="fa fa-external-link edp-color-gray" aria-hidden="true"></i>`,
            link: "https://staging.comunidadeedp.pt",
        },
    ],
    analyticsValue: {
        PT: "GTM-M5KZVFF",
        ES: "G-2KTKYRNL36",
    },
    pushConfig: {
        apiKey: "AIzaSyAn-inSnjn_jLUxY1nZO34xp7IML44VX7o",
        authDomain: "edponline-edp-prd.firebaseapp.com",
        databaseURL: "https://edponline-edp-prd.firebaseio.com",
        projectId: "edponline-edp-prd",
        storageBucket: "edponline-edp-prd.appspot.com",
        messagingSenderId: "358928749613",
        appId: "1:358928749613:web:02e79f28964e9a73a0d4a4",
        measurementId: "G-0GH193L76J",
    },
};
